import React from 'react';
import { UserContextProvider } from './context/UserContext';
import { DictionaryContextProvider } from './context/DictionaryContext';
import Home2 from './components/Home2';
import LoadingSpinner from './components/LoadingSpinner'
import { Routes, Route } from 'react-router-dom';

function App() {
    const defaultUserInfo = {
        user: '',
        // user_name: '',
        isLoggedIn: false,
        jwt: '',
    }


    return (
        <div className="App">
            <UserContextProvider value={defaultUserInfo}> 
                <DictionaryContextProvider>
                    <Routes>
                    {/* <Home2 /> */}
                      <Route path="/" exact={true} element={<Home2 />} />
                      <Route path="/login" element={<Home2 />} />
                    </Routes>
                </DictionaryContextProvider>
            </UserContextProvider>

            <LoadingSpinner size='100px' />
            <LoadingSpinner size='100px' area="no_close" /> 
            <LoadingSpinner size='100px' area="login" />
        </div>
    );
}

export default App;
